module.exports = {"forma-equipos":"Form two teams","continuar":"Continue","azul":"Blue","naranja":"Orange"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/init/en.json
// module id = 177
// module chunks = 8